import type { AssistantVoice, Language } from '@acs/shared';

/**
 * Where the prerecorded sample of one voice speaking one language lives.
 *
 * Twenty-four static clips under `public/voices/<language>/<voice>.mp3`, served
 * by Hosting like any other asset. Deliberately not synthesised on demand: the
 * answer is one of twenty-four fixed files, so a per-press round trip would
 * spend money and a spinner to say what we already know, and being instant is
 * the whole value of the control.
 *
 * `BASE_URL` rather than a leading slash, so the path survives the portal ever
 * being served from a sub-path. A string builder rather than 24 imports: the
 * clips must NOT be bundled — they are 16–23 KB each and nobody opening
 * Settings needs more than one of them.
 *
 * Its own module so the set can be tested against what is actually on disk
 * (see `voiceSample.test.ts`) without importing the settings page, and with it
 * every Firebase binding the page pulls in.
 */
export function voiceSamplePath(language: Language, voice: AssistantVoice): string {
  return `${import.meta.env.BASE_URL}voices/${language}/${voice}.mp3`;
}
